import React from 'react';

const AnnouncementBarContext = React.createContext({});

export default AnnouncementBarContext;
